import { Link } from "react-router-dom";
import {
  DefaultContainer,
  DropDownContainer,
  Header,
  MenuButtonContainer,
  PageContainer,
  PageWrapper,
  UpdateButtonContainer,
} from "./styles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useTheme } from "@mui/material";
import Title from "../../pages/SharedContents/Typography";
import DropDown from "../../pages/SharedContents/DropDown";
import { useEffect, useMemo, useState } from "react";
import {
  getMasterRoles,
  getRolePermissions,
  getUserRoles,
  updateMasterPermisison,
} from "../../services/ApiServices/Roles";
import {
  ModuleProps,
  PermissionsProps,
  SubModuleProps,
} from "./PermissionProps";
import BasicModal from "../ui/BasicModal";
import Loader from "../ui/Loader";
import { CommonButton } from "../../Shared/Components/Buttons/CommonButton";
import useButtonStyles from "../../styles/useButtonStyles";
import { getHeader, getUpdatePermission, mergePermissionModule } from "./utils";
import { SubModulePermission } from "./SubModulePermission/SubModulePermission";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";

const AccessManageMent = () => {
  const { userPermission } = usePermissionGetter("admin", "access_management");
  const theme = useTheme();
  const buttonStyles = useButtonStyles();
  const [selectedRole, setSelectedRole] = useState<string>("");
  const [selectedTab, setSelectedTab] = useState<string>("");
  const [roleOptions, setRoleOptions] = useState<string[]>();
  const [showModal, SetShowModal] = useState<boolean>(false);
  const [masterPermissionModule, setMasterPermissionModule] =
    useState<ModuleProps>({});
  const [masterPermissionSubModule, setMasterPermissionSubModule] =
    useState<SubModuleProps>({});
  const [rolePermission, setRolePermission] = useState<ModuleProps>({});
  const [isAPILoading, setAPILoading] = useState<boolean>(true);
  const [defaultRoleSettings, setDefaultRoleSettings] =
    useState<SubModuleProps>({});
  const [initialPermissionModule, setInitialPermissionValue] =
    useState<ModuleProps>({});
  const [userUpdatedPermission, setUserUpdatedPermission] =
    useState<ModuleProps>(initialPermissionModule);
  const [rowHeader, setRowHeader] = useState<string[]>([]);
  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    resetData();
  }, [selectedRole]);

  useEffect(() => {
    setRowHeader(getHeader(masterPermissionSubModule));
  }, [masterPermissionSubModule]);
  useEffect(() => {
    const _updatedUserPermission: ModuleProps = mergePermissionModule(
      JSON.stringify(masterPermissionModule),
      JSON.stringify(rolePermission)
    );
    setInitialPermissionValue(_updatedUserPermission);
    setUserUpdatedPermission(_updatedUserPermission);
  }, [masterPermissionModule]);

  const resetData = () => {
    setMasterPermissionModule({});
    setMasterPermissionSubModule({});
    setRolePermission({});
    setDefaultRoleSettings({});
    selectedRole && getMasterPermission(selectedRole);
  };

  const onRoleSelected = (role: string) => {
    setSelectedRole(role);
  };
  const getMasterPermission = async (role: string) => {
    setAPILoading(true);
    const { permissions } = await getRolePermissions(role);
    const { permissions_v2 } = permissions;
    const role_permission = permissions_v2 ? JSON.parse(permissions_v2) : {};
    setRolePermission(role_permission);
    const { masterPermissions } = await getMasterRoles(role);
    setMasterPermissionModule(masterPermissions);
    setAPILoading(false);
  };
  const getUser = async () => {
    const roles = await getUserRoles();
    const roleMenus = roles?.map((item: any) => {
      return item.name;
    });
    setRoleOptions(roleMenus);
    setAPILoading(false);
  };
  const handleTabChange = (activeTab: string) => {
    if (activeTab?.trim() !== "") {
      setMasterPermissionSubModule(masterPermissionModule[activeTab]);
      initialPermissionModule?.hasOwnProperty(activeTab) &&
        setDefaultRoleSettings(initialPermissionModule[activeTab]);
      setSelectedTab(activeTab);
    }
  };

  const onUserUpdate = (data: PermissionsProps, moduleName: string) => {
    if (data) {
      const userChangedKey = Object.keys(data)[0];
      userUpdatedPermission[selectedTab][moduleName][userChangedKey] =
        data[userChangedKey];
    }
  };

  const onUpdatePermission = async () => {
    const data = getUpdatePermission(userUpdatedPermission, selectedRole);
    setAPILoading(true);
    const _updatePermisisonResponse = await updateMasterPermisison(data);
    if (_updatePermisisonResponse.message) {
      SetShowModal(true);
    }
    setAPILoading(false);
    resetData();
  };

  return (
    <PageWrapper color={theme.color?.background}>
      <PageContainer>
        <Header>
          <Link to={"/admin"}>
            <ArrowBackIosIcon fontSize="small" />
          </Link>
          <Title
            title="Access Management"
            fontfamily={theme.font?.fontFamily.primary}
            weight={theme.font?.fontWeight.thick}
            size={theme.font?.fontSize.large}
            color={theme.color?.dark}
          />
        </Header>
        <MenuButtonContainer>
          <DropDownContainer>
            <DropDown
              label="Select Role"
              options={roleOptions}
              value={selectedRole}
              onChange={onRoleSelected}
            />
          </DropDownContainer>
          <UpdateButtonContainer>
            {userPermission.update && (
              <CommonButton
                buttonTitle="Update"
                variant="contained"
                sx={{
                  ...buttonStyles.containedSecondary,
                  width: "30%",
                  textAlign: "right",
                }}
                onClick={onUpdatePermission}
              />
            )}
          </UpdateButtonContainer>
        </MenuButtonContainer>
        {Object.keys(masterPermissionModule).length > 0 ? (
          <SubModulePermission
            masterPermissionModule={masterPermissionModule}
            handleTabChange={handleTabChange}
            rowHeader={rowHeader}
            defaultRoleSettings={defaultRoleSettings}
            masterPermissionSubModule={masterPermissionSubModule}
            onUserUpdate={onUserUpdate}
          />
        ) : (
          <DefaultContainer>
            <Title title="Please Select a Role" />
          </DefaultContainer>
        )}
        {showModal && (
          <BasicModal
            title={"User permissions Updated Successfully!"}
            success={true}
            setState={SetShowModal}
          />
        )}
        {isAPILoading && <BasicModal content={<Loader />} />}
      </PageContainer>
    </PageWrapper>
  );
};
export default AccessManageMent;
